import { getGetVenuaPlannerTreeQueryKey } from '@/api/generated/venua-planner-planning/venua-planner-planning';

/**
 * Lehká reference na destinaci (sdílený contract s backend `DestinationRef`).
 * Je součástí read modelu stromu (`PlanningProjectNodeResponse.destinations`).
 *
 * Uzly stromu (`GetPlanningTreeResponse` a `Planning*NodeResponse`) se konzumují přímo
 * z `@/api/generated/schemas` — jediný zdroj pravdy je generovaný OpenAPI kontrakt.
 */
export interface DestinationRef {
  destinationId: number;
  name: string;
  code?: string | null;
}

/**
 * Lehká reference na osobu (Party). `partyId` = Party.Id aktuálně platné osoby.
 * UI hodnota odpovědných osob ve formulářích projektu i série.
 */
export interface PersonRef {
  partyId: number;
  fullName: string;
}

/**
 * React-query klíče pro venua-planner slice. Strom se čte generovaným hookem
 * `useGetVenuaPlannerTree` (dřív ruční `fetch` — porušení GUIDELINES §7). `tree()` proto deleguje
 * na jeho query key, aby invalidace z formulářů (projekt/produkt/série/termín) trefila stejnou
 * cache jako plánovací i kalendářová agenda. Prefix bez parametrů invaliduje všechny varianty
 * filtrů (typ dopravy / historie).
 */
export const venuaPlannerQueryKeys = {
  all: ['venua-planner'] as const,
  tree: () => getGetVenuaPlannerTreeQueryKey(),
} as const;
